import { useNavigate, useLocation, useParams } from "react-router-dom";

// A Higher-Order Component to inject router props into class components
function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    return (
      <Component
        {...props}
        match={{ params: params, url: location.pathname }}
        location={location}
        redirect={navigate}
      />
    );
  }

  return ComponentWithRouterProp;
}

export default withRouter;
